import { connect, mapProps } from '@formily/react'
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'
import { cn } from '@/lib/utils'

export interface RadioOption {
  label: string
  value: any
  disabled?: boolean
}

export interface FormilyRadioProps {
  value?: any
  onChange?: (value: any) => void
  options?: RadioOption[]
  dataSource?: RadioOption[]
  className?: string
  disabled?: boolean
}

const InternalRadio = ({
  value,
  onChange,
  options = [],
  className,
  disabled,
  ...props
}: FormilyRadioProps) => {
  return (
    <RadioGroup
      value={value}
      onValueChange={onChange}
      className={cn(
        'flex flex-row space-x-2 justify-start items-center',
        className,
      )}
      disabled={disabled}
    >
      {options.map((option) => (
        <div key={option.value} className="flex items-center space-x-2">
          <RadioGroupItem
            value={option.value}
            id={`radio-${option.value}`}
            disabled={option.disabled || disabled}
          />
          <label
            htmlFor={`radio-${option.value}`}
            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
          >
            {option.label}
          </label>
        </div>
      ))}
    </RadioGroup>
  )
}

export const FormilyRadio = connect(
  InternalRadio,
  mapProps({
    dataSource: 'options',
  }),
)
